module.exports = __webpack_public_path__ + "static/media/studio3-2.f40362c7.png";